import { useQuery } from "@tanstack/react-query"
import { api, ResponseNotOkError } from "@/api"
import type { QueryFunctionContext } from "@tanstack/react-query"
import type { LedgerSettingsResponse } from "@/types/djangio"

const queryKeys = {
    all: [{ _model: "ledgerreportingjurisdiction" }, { _model: "ledgersettings" }],
    ledgerSettingsDetail: (id: string) => [{ ...queryKeys.all[1], id }] as const,
}

const fetchLedgerSettings = async ({
    queryKey,
}: QueryFunctionContext<ReturnType<(typeof queryKeys)["ledgerSettingsDetail"]>>): Promise<LedgerSettingsResponse> => {
    const [{ id }] = queryKey

    const response = await api.get(`/api/ledgersettings/${id}/`)
    if (!response.ok) {
        throw new ResponseNotOkError(response, "Unable to get LedgerSettings")
    }
    return response.json()
}

export const useLedgerSettings = (id: string) =>
    useQuery({
        queryKey: queryKeys.ledgerSettingsDetail(id),
        queryFn: fetchLedgerSettings,
        enabled: Boolean(id),
        select: (queryResultData) => {
            return {
                paccPacParameters: queryResultData.pacc_pac_parameters,
            }
        },
    })
